<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :no-data-text="$t('noDataText')"
      :items-per-page="15"
    >
      <template #[`item.idVisite`]="{ item }">
        <div>
          <add-to-calendar
            title="Bilan CIEM"
            :start="new Date(item.debut)"
            :end="new Date(item.fin)"
            :details="item.objet"
            inline-template
          >
            <div style="display: inline-block">
              <google-calendar id="office365-calendar">
                <v-icon title="Google Calendar">mdi-calendar-plus</v-icon>
              </google-calendar>
            </div>
          </add-to-calendar>
          <v-icon title="Outlook" v-on:click="openICS(item)"
            >local_post_office</v-icon
          >
        </div>
      </template>
      <template #[`item.debut`]="{ item }">
        {{ formatDate(item.debut) }}
      </template>

      <template #[`item.bilanEnCours`]="{ item }">
        <v-icon v-if="item.bilanEnCours == true">mdi-check</v-icon>
        <v-icon v-if="item.bilanEnCours == false"
          >mdi-checkbox-blank-outline</v-icon
        >
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Api from '@/utils/api'
import moment from 'moment'

export default {
  props: {
    fieldName: {
      type: String,
      default: '_calendar',
    },
    capabilities: {
      type: String,
      default: '',
    },
    rowsSize: {
      type: Number,
      default: 15,
    },
    callRefresh: {
      type: Boolean,
      default: true,
    },
  },
  beforeCreate() {
    new Api('participant/rdvs-participant')
      .get()
      .then((response) => {
        this.items = response.body
      })
      .catch(() => {
        // TODO gestion du cas d'erreur not found
      })
  },
  data() {
    return {
      items: [],
      headers: [
        {
          value: 'idVisite',
          text: this.$t('participant.rendezvous.ajouter'),
          sortable: false,
        },
        {
          value: 'objet',
          text: this.$t('participant.rendezvous.objet'),
          sortable: false,
        },
        {
          value: 'debut',
          text: this.$t('participant.rendezvous.debut'),
          width: '200px',
        },
        {
          value: 'bilanEnCours',
          text: this.$t('participant.rendezvous.bilanEnCours'),
          sortable: false,
        },
        {
          value: 'cardiologue',
          text: this.$t('participant.rendezvous.cardiologue'),
          sortable: false,
        },
        {
          value: 'interniste',
          text: this.$t('participant.rendezvous.interniste'),
          sortable: false,
        },
        {
          value: 'gynecologue',
          text: this.$t('participant.rendezvous.gynecologue'),
          sortable: false,
        },
        {
          value: 'statut',
          text: this.$t('participant.rendezvous.statut'),
          sortable: false,
        },
      ],
    }
  },
  methods: {
    selectedItemTraitements(item) {
      this.$emit('item-selected', item)
    },

    formatDate(value) {
      const date = value ? moment(value).local().format('DD/MM/YYYY HH:mm') : ''
      return date
    },

    formatDateJour(value) {
      const date = value ? moment(value).local().format('DD/MM/YYYY') : ''
      return date
    },
    openICS(item) {
      this.$ics.removeAllEvents()
      this.$ics.addEvent(
        'FR',
        'bilan_' + this.formatDateJour(item.debut),
        '',
        'CIEM',
        item.debut,
        item.fin,
        '',
        null,
        null,
      )
      if (item.objet) {
        this.$ics.download('calendar_' + item.objet)
      }
    },
  },
}
</script>
